import { CFooter } from '@coreui/react';
import { memo } from 'react';

const AppFooter = () => {
    return <CFooter />;
};

export default memo(AppFooter);
